<template>
  <AlertBox v-if="showPremiumAlert" @closeAlert="showPremiumAlert = false">
    <div class="premium-upgrade-box">
      <img src="../../assets/img/premium-icon.svg" alt="" />
      <h4 class="gradient-text">Pro feature only</h4>
      <p>Upgrade to PRO account to unlock more features and access to our full PRO library.</p>
      <RouterLink class="pricing-link" to="/pricing">View Plans</RouterLink>
    </div>
  </AlertBox>
  <AlertBox v-if="showInfoAlert" @closeAlert="showInfoAlert = false">
    <h4>Scene Preview</h4>
    <p>{{ SCENE_INFO_TEXT }}</p>
  </AlertBox>
  <div autofocus>
    <div
      class="loading-spinner-overlay"
      id="loading-spinner-overlay"
      ref="loadingSpinnerRef"
      style="display: none"
    >
      <div class="loading-spinner"></div>
    </div>
    <div class="scene-info-container">
      <h2 class="scene-title">Scene preview</h2>
      <img src="@/assets/img/info-icon.svg" alt="" @click="showInfoAlert = true" />
    </div>

    <MobileSearch :isScene="true" :typewriterWords="flareSearchSuggestions" />

    <div class="heading">
      <div class="icon">
        <img style="display: none" id="iconImage" ref="iconRef" />
      </div>
      <div class="focalLength">
        <select
          id="focalLength"
          name="focalLength"
          ref="focalLengthRef"
          style="display: none"
          @mousedown="handleFocalLengthClick"
          @change="setFocalLengthChange($event)"
        >
          <option v-for="option in store.focalLengthOptionsRight" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>
      <div class="transmission">
        <select
          id="transmission"
          name="transmission"
          ref="transmissionRef"
          style="display: none"
          @mousedown="handleTransmissionClick"
          @change="setTransmissionChange($event)"
        >
          <option v-for="option in store.transmissionsRight" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <div class="slider-container" ref="sliderContainer" style="position: relative">
        <div class="spinner-container" v-if="sliderLoading">
          <div class="spinner-load"></div>
        </div>

        <!-- Left save Button -->
        <SaveBtn
          :status="leftSaveBtnStatus"
          :loading="leftSaveBtnLoading"
          @click="addWishlist('LEFT')"
          :viewCondition="!isFullScreen"
          :sceneSave="{ isScene: true, isLeft: true }"
          :show-label="false"
        />

        <!-- Right save Button -->
        <SaveBtn
          :status="rightSaveBtnStatus"
          :loading="rightSaveBtnLoading"
          @click="addWishlist('RIGHT')"
          :viewCondition="!isFullScreen"
          :sceneSave="{ isScene: true, isLeft: false }"
          :show-label="false"
        />

        <!-- Left Arrow Button -->
        <div
          class="arrow-btn left-arrow"
          :class="{ active: activeSide === 'LEFT' }"
          @click="activeSide = 'LEFT'"
          ref="leftArrowRef"
        >
          <i class="fas fa-chevron-left"></i>
        </div>

        <ImgComparisonSlider
          style="display: block; width: 100%"
          class="image-comparison-slider"
          ref="comparisonSliderRef"
        >
          <!-- eslint-disable -->

          <img
            slot="first"
            style="width: 100%; aspect-ratio: 2.4 / 1"
            ref="sceneBackgroundRef"
            src="@/assets/img/scene_load.png"
            class="fade-in-image"
          />

          <svg
            width="25"
            slot="handle"
            viewBox="0 0 425 614"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="425" height="614" rx="212" fill="white" />
            <path
              d="M146 202.5V412.5C146 422.16 138.16 430 128.5 430C118.84 430 111 422.16 111 412.5V202.5C111 192.84 118.84 185 128.5 185C138.16 185 146 192.84 146 202.5ZM195 202.5V412.5C195 422.16 202.84 430 212.5 430C222.16 430 230 422.16 230 412.5V202.5C230 192.84 222.16 185 212.5 185C202.84 185 195 192.84 195 202.5ZM279 202.5V412.5C279 422.16 286.84 430 296.5 430C306.16 430 314 422.16 314 412.5V202.5C314 192.84 306.16 185 296.5 185C286.84 185 279 192.84 279 202.5Z"
              fill="black"
            />
          </svg>

          <img
            slot="second"
            style="width: 100%; aspect-ratio: 2.4 / 1"
            ref="sceneLensRef"
            src="@/assets/img/scene_load.png"
            class="fade-in-image"
          />

          <!-- eslint-enable -->
        </ImgComparisonSlider>

        <!-- Right Arrow Button -->
        <div
          class="arrow-btn right-arrow"
          :class="{ active: activeSide === 'RIGHT' }"
          @click="activeSide = 'RIGHT'"
          ref="rightArrowRef"
        >
          <i class="fas fa-chevron-right"></i>
        </div>

        <div class="scene-fullscreen" @click="requestSceneFullscreen()" v-if="canFullScreen">
          <img src="@/assets/img/fullscreen.svg" width="12" v-if="!isFullScreen" />
          <img src="@/assets/img/exit-fullscreen.svg" width="15" v-else />
        </div>
      </div>
    </div>
    <div class="scene-control-wrapper scene-control-mobile">
      <div class="scene-control-right">
        <span
          class="scene-tab"
          :class="{ 'tab-active': store.sceneType === 'desert' }"
          @click="setSceneType('desert')"
          >DESERT</span
        >
        <span
          class="scene-tab"
          :class="{ 'tab-active': store.sceneType === 'night' }"
          @click="handlePremiumAlert()"
          >NIGHT</span
        >
      </div>
    </div>
    <div
      class="lenslist-container"
      style="position: relative; height: 30vh; overflow: hidden; width: 100%"
    >
      <!-- Left Vertical Scrolling Menu (Visible when activeSide is LEFT) -->
      <SceneWheelPicker ref="leftPickerRef" side="LEFT" :activeSide="activeSide" />

      <!-- Right Vertical Scrolling Menu (Visible when activeSide is RIGHT) -->
      <SceneWheelPicker ref="rightPickerRef" side="RIGHT" :activeSide="activeSide" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch, ref, onUnmounted, computed, nextTick } from 'vue'
import { storeToRefs } from 'pinia'
import { useScenesStore } from '@/stores/Scenes'
import { usePremiumLock } from '@/composable/Premium.js'
import { useLensesStore } from '@/stores/Lenses'
import { useUsersStore } from '@/stores/Users'
import MobileSearch from '../MobileComponents/MobileSearch.vue'
import AlertBox from '../AlertBox.vue'
import '../../styles/MobileComponents/MiddleContainer.css'
import { ImgComparisonSlider } from '@img-comparison-slider/vue'
import { addToWishlist, removeFromWishlist } from '@/api/wishlist'
import SaveBtn from '../Selects/SaveBtn.vue'
import {
  findlensesExistanceInSceneType,
  getCategoryName,
  getSceneType,
  requestFullScreen
} from '@/includes/scene'
import { useWishlistStore } from '@/stores/Wishlist'
import { ampli } from '@/ampli'
import { useRouter } from 'vue-router'
import { flareSearchSuggestions, SCENE_INFO_TEXT } from '@/utils/constants'
import { fallbackLens, findSceneAnchorName } from '@/includes/lens'

const store = useScenesStore()
const focalLengthRef = ref(null)
const transmissionRef = ref(null)
const iconRef = ref(null)
const loadingSpinnerRef = ref(null)

const activeSide = computed({
  get: () => store.activeSide,
  set: val => store.setActiveSide(val)
})
import SceneWheelPicker from './SceneWheelPicker.vue'

const leftPickerRef = ref(null)
const rightPickerRef = ref(null)

const leftViewport = computed(() => leftPickerRef.value?.viewport)
const rightViewport = computed(() => rightPickerRef.value?.viewport)

const leftSingleVideoDetail = ref(null)
const rightSingleVideoDetail = ref(null)
const leftSaveBtnStatus = ref(null)
const rightSaveBtnStatus = ref(null)
const leftSaveBtnLoading = ref(false)
const rightSaveBtnLoading = ref(false)
const singleVideoDetail = ref(null)
const saveBtnStatus = ref(null)
const saveBtnLoading = ref(false)
const sliderLoading = ref(false)
const sceneBackgroundRef = ref(null)
const sceneLensRef = ref(null)
const sliderContainer = ref(null)
const isFullScreen = ref(false)
const canFullScreen = ref(null)
const showPremiumAlert = ref(false)
const showInfoAlert = ref(false)

const {
  handleTransmissionClick: _lockTransmission,
  handleFocalLengthClick: _lockFocalLength,
  guardSave
} = usePremiumLock({
  leftDetail: leftSingleVideoDetail,
  rightDetail: rightSingleVideoDetail,
  isPremiumUser: computed(() => store.isPremiumUser),
  onLocked: () => {
    showPremiumAlert.value = true
  }
})

const handleTransmissionClick = event => _lockTransmission(event, activeSide.value)
const handleFocalLengthClick = event => _lockFocalLength(event, activeSide.value)

// Refs for slider clamping — measure arrow + save button widths to restrict the slider handle
const leftArrowRef = ref(null)
const rightArrowRef = ref(null)
const comparisonSliderRef = ref(null)
let resizeObserver = null

/**
 * Clamp the slider handle so it cannot travel underneath the arrow buttons or save buttons.
 * Calculates left/right dead-zone widths in pixels, converts to a percentage of the slider width,
 * and sets these limits on the slider element to natively clamp the slider position.
 */
const updateSliderBounds = () => {
  const sliderEl = comparisonSliderRef.value?.$el || comparisonSliderRef.value
  if (!sliderEl) return

  const sliderWidth = sliderEl.offsetWidth
  if (!sliderWidth) return

  // Measure the left arrow and left save button
  const leftArrowWidth = leftArrowRef.value?.offsetWidth || 0
  const leftSaveBtn = sliderEl.parentElement?.querySelector('.vide-save-btn.left-side-save')
  const leftSaveWidth = leftSaveBtn ? leftSaveBtn.offsetLeft + leftSaveBtn.offsetWidth : 0

  const leftDeadZone = Math.max(leftArrowWidth, leftSaveWidth)

  // Measure the right arrow and right save button
  const rightArrowWidth = rightArrowRef.value?.offsetWidth || 0
  const rightSaveBtn = sliderEl.parentElement?.querySelector('.vide-save-btn:not(.left-side-save)')
  const rightSaveWidth = rightSaveBtn ? sliderWidth - rightSaveBtn.offsetLeft : 0

  const rightDeadZone = Math.max(rightArrowWidth, rightSaveWidth)

  // Add a small buffer (5px) so the handle doesn't sit right at the button edge
  const minPercent = ((leftDeadZone + 10) / sliderWidth) * 100
  const maxPercent = 100 - ((rightDeadZone + 10) / sliderWidth) * 100

  sliderEl._minPercent = minPercent
  sliderEl._maxPercent = maxPercent

  if (sliderEl.exposure !== undefined) {
    if (sliderEl.exposure < minPercent) {
      sliderEl.value = minPercent
    } else if (sliderEl.exposure > maxPercent) {
      sliderEl.value = maxPercent
    }
  }
}

const {
  LeftSelectedVideoId,
  RightSelectedVideoId,
  LeftFocalLength,
  RightFocalLength,
  LeftTransmission,
  RightTransmission,
  SelectedVideo,
  SelectedFocalLength,
  SelectedTransmission,
  sceneType
} = storeToRefs(store)

const wishlistStore = useWishlistStore()
const userStore = useUsersStore()

const router = useRouter()
let currentPathObject = router.currentRoute.value

const sceneWishlist = computed(() => wishlistStore.wishlist.filter(item => item.sceneImageUrl))

const handlePremiumAlert = () => {
  if (userStore?.userDetails?.isPremiumUser) {
    showPremiumAlert.value = false
    setSceneType('night')
  } else {
    showPremiumAlert.value = true
  }
}

const handleUnsave = async (lensId, target) => {
  let currentScene = getSceneType('', store.sceneType)

  const wishlistData = sceneWishlist.value.find(
    wishlist => wishlist.lensId === lensId && wishlist.sceneImageType === currentScene.sceneType
  )

  if (!wishlistData) return
  await removeFromWishlist(wishlistData.id)

  wishlistStore.removeFromWishlist(wishlistData.id)

  if (target === 'LEFT') {
    leftSaveBtnLoading.value = false
  } else if (target === 'RIGHT') {
    rightSaveBtnLoading.value = false
  } else {
    saveBtnLoading.value = false
  }
}

const addWishlist = async target => {
  if (guardSave(target)) return

  let videoObject
  let status
  let lensCategoryName

  if (target === 'LEFT') {
    const items = store.LeftSelectedVideoDetails
    videoObject = items.filter(item => {
      return (
        item?.focalLength === store.LeftFocalLength && item?.transmission === store.LeftTransmission
      )
    })
    status = leftSaveBtnStatus.value
    leftSaveBtnLoading.value = true
  } else if (target === 'RIGHT') {
    const items = store.RightSelectedVideoDetails
    videoObject = items.filter(item => {
      return (
        item?.focalLength === store.RightFocalLength &&
        item?.transmission === store.RightTransmission
      )
    })
    status = rightSaveBtnStatus.value
    rightSaveBtnLoading.value = true
  } else {
    // Single / Legacy mode fallback
    const items = store.SelectedVideoDetails
    videoObject = items.filter(item => {
      return (
        item?.focalLength === store.SelectedFocalLength &&
        item?.transmission === store.SelectedTransmission
      )
    })
    status = saveBtnStatus.value
    saveBtnLoading.value = true
  }

  const selectedScene = videoObject[0]
  if (!selectedScene) {
    if (target === 'LEFT') leftSaveBtnLoading.value = false
    else if (target === 'RIGHT') rightSaveBtnLoading.value = false
    else saveBtnLoading.value = false
    return
  }

  const { id: lensId, name, focalLength, transmission, videoPath } = selectedScene
  lensCategoryName = getCategoryName(lensId, store.data)

  if (status === 'saved') {
    handleUnsave(lensId, target)
    return
  }

  const payload = {
    lensId,
    name,
    focalLength,
    transmission,
    sceneImageType: getSceneType(selectedScene, store.sceneType).sceneType,
    sceneImageUrl: getSceneType(selectedScene, store.sceneType).sceneImageUrl,
    videoPath,
    categoryName: lensCategoryName
  }

  /*
    AMPLITUDE: Track lens saved
    Triggers when a lens save button is clicked
  */
  ampli.lensSaved({
    lensId: lensId,
    lensName: name,
    focalLength: focalLength,
    transmission: transmission,
    page: currentPathObject?.fullPath
  })

  const response = await addToWishlist(payload)

  if (response.status === 200) {
    wishlistStore.addToWishlist(response.data)
  }

  if (target === 'LEFT') {
    leftSaveBtnLoading.value = false
  } else if (target === 'RIGHT') {
    rightSaveBtnLoading.value = false
  } else {
    saveBtnLoading.value = false
  }
}

const generateSaveIcon = () => {
  if (!singleVideoDetail.value) return
  const { id } = singleVideoDetail.value

  let idArray = []

  sceneWishlist.value?.forEach(obj => {
    idArray.push({ lensId: obj.lensId, sceneType: obj.sceneImageType })
  })

  let currentScene = getSceneType('', store.sceneType)

  for (const object of idArray) {
    if (object.lensId === id && object.sceneType === currentScene.sceneType) {
      saveBtnStatus.value = 'saved'
      return
    }
  }

  saveBtnStatus.value = 'unsaved'
}

const generateLeftSaveIcon = () => {
  if (!leftSingleVideoDetail.value) return
  const { id } = leftSingleVideoDetail.value

  let idArray = []

  sceneWishlist.value?.forEach(obj => {
    idArray.push({ lensId: obj.lensId, sceneType: obj.sceneImageType })
  })

  let currentScene = getSceneType('', store.sceneType)

  for (const object of idArray) {
    if (object.lensId === id && object.sceneType === currentScene.sceneType) {
      leftSaveBtnStatus.value = 'saved'
      return
    }
  }

  leftSaveBtnStatus.value = 'unsaved'
}

const generateRightSaveIcon = () => {
  if (!rightSingleVideoDetail.value) return
  const { id } = rightSingleVideoDetail.value

  let idArray = []

  sceneWishlist.value?.forEach(obj => {
    idArray.push({ lensId: obj.lensId, sceneType: obj.sceneImageType })
  })

  let currentScene = getSceneType('', store.sceneType)

  for (const object of idArray) {
    if (object.lensId === id && object.sceneType === currentScene.sceneType) {
      rightSaveBtnStatus.value = 'saved'
      return
    }
  }

  rightSaveBtnStatus.value = 'unsaved'
}

const canFullscreen = (function () {
  for (const key of [
    'exitFullscreen',
    'webkitExitFullscreen',
    'webkitCancelFullScreen',
    'mozCancelFullScreen',
    'msExitFullscreen'
  ]) {
    if (key in document) {
      return true
    }
  }
  return false
})()

const requestSceneFullscreen = () => {
  if (isFullScreen.value) {
    document.exitFullscreen()
  } else {
    requestFullScreen(sliderContainer.value)
  }
}

const handleFullscreen = () => {
  if (document.fullscreenElement) {
    isFullScreen.value = true
  } else {
    isFullScreen.value = false
  }
}

onMounted(async () => {
  const lensesStore = useLensesStore()
  if (lensesStore.SelectedVideo) {
    const cleanName = lensesStore.SelectedVideo
    if (store.activeSide === 'RIGHT') {
      store.setRightSelectedVideoId(cleanName + '-right')
      if (lensesStore.SelectedFocalLength) {
        store.setRightFocalLength(lensesStore.SelectedFocalLength)
      }
      if (lensesStore.SelectedTransmission) {
        store.setRightTransmission(lensesStore.SelectedTransmission)
      }
    } else {
      store.setLeftSelectedVideoId(cleanName + '-left')
      if (lensesStore.SelectedFocalLength) {
        store.setLeftFocalLength(lensesStore.SelectedFocalLength)
      }
      if (lensesStore.SelectedTransmission) {
        store.setLeftTransmission(lensesStore.SelectedTransmission)
      }
    }
  }

  await store.fetchData()

  let defaultLeft = store.LeftSelectedVideoId || store.defaultLeftVideoId
  let defaultRight = store.RightSelectedVideoId || store.defaultRightVideoId

  const leftAnchor = findSceneAnchorName(defaultLeft, store.data)
  const rightAnchor = findSceneAnchorName(defaultRight, store.data)

  if (!leftAnchor) {
    console.error('Left anchor not found, setting the first lens as default')
    const fallbackLeft = fallbackLens('Left', store.data)
    if (fallbackLeft) {
      defaultLeft = fallbackLeft
    }
  }
  if (!rightAnchor) {
    console.error('Right anchor not found, setting the first lens as default')
    const fallbackRight = fallbackLens('Right', store.data)
    if (fallbackRight) {
      defaultRight = fallbackRight
    }
  }

  store.setLeftSelectedVideoId(defaultLeft)
  store.setRightSelectedVideoId(defaultRight)
  store.setLeftSelectedVideoDetails()
  store.setRightSelectedVideoDetails()

  if (store.LeftSelectedVideoDetails && store.LeftSelectedVideoDetails.length > 0) {
    if (!store.LeftFocalLength) {
      store.setLeftFocalLength(store.LeftSelectedVideoDetails[0].focalLength)
    }
    if (!store.LeftTransmission) {
      store.setLeftTransmission(store.LeftSelectedVideoDetails[0].transmission)
    }
    leftSingleVideoDetail.value = store.LeftSelectedVideoDetails.find(
      s => s?.focalLength === store.LeftFocalLength && s?.transmission === store.LeftTransmission
    )
  }
  if (store.RightSelectedVideoDetails && store.RightSelectedVideoDetails.length > 0) {
    if (!store.RightFocalLength) {
      store.setRightFocalLength(store.RightSelectedVideoDetails[0].focalLength)
    }
    if (!store.RightTransmission) {
      store.setRightTransmission(store.RightSelectedVideoDetails[0].transmission)
    }
    rightSingleVideoDetail.value = store.RightSelectedVideoDetails.find(
      s => s?.focalLength === store.RightFocalLength && s?.transmission === store.RightTransmission
    )
  }

  let defaultMobile = store.defaultMobileVideoId
  const leftAnchorMobile = findSceneAnchorName(defaultMobile, store.data)

  if (!leftAnchorMobile) {
    console.error('Left anchor not found, setting the first lens as default')
    const fallback = fallbackLens('', store.data)
    if (fallback) {
      defaultMobile = fallback
    }
  }
  store.setSelectedVideo(defaultMobile)

  if (leftViewport.value) {
    store.addHeightOntopAndBottom(leftViewport)
  }
  if (rightViewport.value) {
    store.addHeightOntopAndBottom(rightViewport)
  }

  document.addEventListener('fullscreenchange', handleFullscreen)

  if (canFullscreen) {
    canFullScreen.value = true
  } else {
    canFullScreen.value = false
  }

  await loadMobileLenses()
  reloadFocalLength('LEFT')
  reloadTransmission('LEFT')
  generateLeftSaveIcon()
  generateRightSaveIcon()
  updateActiveIcon()

  // Patch custom element prototype once safely
  // This ensures the slider handle is clamped before its CSS properties are updated, resulting in a smooth drag with zero flickering.
  const patchSliderClass = () => {
    const SliderClass = customElements.get('img-comparison-slider')
    if (SliderClass && SliderClass.prototype) {
      if (!SliderClass.prototype._isPatched) {
        SliderClass.prototype._isPatched = true
        const originalSetExposure = SliderClass.prototype.setExposure
        SliderClass.prototype.setExposure = function (t = 0) {
          if (t !== 0) {
            this.exposure += t
          }
          if (this._minPercent !== undefined && this.exposure < this._minPercent) {
            this.exposure = this._minPercent
          } else if (this._maxPercent !== undefined && this.exposure > this._maxPercent) {
            this.exposure = this._maxPercent
          }
          originalSetExposure.call(this, 0)
        }
      }
      return true
    }
    return false
  }

  if (!patchSliderClass()) {
    customElements.whenDefined('img-comparison-slider').then(() => {
      patchSliderClass()
    })
  }

  // Setup ResizeObserver to dynamically update bounds whenever the slider size changes
  const sliderEl = comparisonSliderRef.value?.$el || comparisonSliderRef.value
  if (sliderEl) {
    resizeObserver = new ResizeObserver(() => {
      updateSliderBounds()
    })
    resizeObserver.observe(sliderEl)
  }

  window.addEventListener('resize', updateSliderBounds)

  await nextTick()
  updateSliderBounds()

  if (store.LeftSelectedVideoId) {
    const listItem = document.getElementById(store.LeftSelectedVideoId)
    if (listItem) {
      setTimeout(() => {
        store.scrollToItem(listItem)
      }, 100)
    }
  }
  if (store.RightSelectedVideoId) {
    const listItem = document.getElementById(store.RightSelectedVideoId)
    if (listItem) {
      setTimeout(() => {
        store.scrollToItem(listItem)
      }, 100)
    }
  }
})

onUnmounted(() => {
  document.removeEventListener('fullscreenchange', handleFullscreen)
  window.removeEventListener('resize', updateSliderBounds)
  if (resizeObserver) {
    resizeObserver.disconnect()
  }
})

function setFocalLengthChange(event) {
  const selected = event.target.value
  if (activeSide.value === 'LEFT') {
    store.setLeftFocalLength(selected)
  } else {
    store.setRightFocalLength(selected)
  }
}
function setTransmissionChange(event) {
  const selected = event.target.value
  if (activeSide.value === 'LEFT') {
    store.setLeftTransmission(selected)
  } else {
    store.setRightTransmission(selected)
  }
}

async function reloadFocalLength(target) {
  const lensesDetails =
    target === 'LEFT' ? store.LeftSelectedVideoDetails : store.RightSelectedVideoDetails

  if (!lensesDetails) return

  const uniqueFocalLengths = []
  const seen = new Set()
  lensesDetails.forEach(item => {
    if (item?.focalLength && !seen.has(item.focalLength)) {
      seen.add(item.focalLength)
      uniqueFocalLengths.push(item.focalLength)
    }
  })

  uniqueFocalLengths.sort((a, b) => {
    const valA = parseFloat(a.replace('mm', '')) || 0
    const valB = parseFloat(b.replace('mm', '')) || 0
    return valA - valB
  })

  // Update the reactive array that already drives the template's <option v-for> -
  // rebuilding the <option> elements by hand here fought Vue's own patching of
  // the same <select> (that's what caused the insertBefore/patchProp crashes)
  store.focalLengthOptionsRight = uniqueFocalLengths

  await nextTick()
  if (focalLengthRef.value) {
    focalLengthRef.value.style.display = 'block'
  }
}

async function reloadTransmission(target) {
  const lensesDetails =
    target === 'LEFT' ? store.LeftSelectedVideoDetails : store.RightSelectedVideoDetails

  if (!lensesDetails) return

  lensesDetails.sort((a, b) => {
    const focalLengthA = a?.focalLength ? parseFloat(a?.focalLength.replace('mm', '')) : 0
    const focalLengthB = b?.focalLength ? parseFloat(b?.focalLength.replace('mm', '')) : 0
    const transmissionA = a.transmission
      ? parseFloat(a.transmission.toString().replace(/[^0-9.]/g, ''))
      : 0
    const transmissionB = b?.transmission
      ? parseFloat(b?.transmission.toString().replace(/[^0-9.]/g, ''))
      : 0
    const focalDiff = focalLengthA - focalLengthB
    if (focalDiff !== 0) {
      return focalDiff
    }
    return transmissionA - transmissionB
  })

  const focalLengthVal = target === 'LEFT' ? store.LeftFocalLength : store.RightFocalLength
  const transmissonOptions = lensesDetails.filter(s => s?.focalLength === focalLengthVal)

  // Update the reactive array that already drives the template's <option v-for> -
  // rebuilding the <option> elements by hand here fought Vue's own patching of
  // the same <select> (that's what caused the insertBefore/patchProp crashes)
  store.transmissionsRight = transmissonOptions.map(option => option.transmission)

  const currentTransmission = transmissonOptions[0]?.transmission
  if (target === 'LEFT') {
    store.setLeftTransmission(currentTransmission)
  } else {
    store.setRightTransmission(currentTransmission)
  }

  await nextTick()
  if (transmissionRef.value) {
    transmissionRef.value.style.display = 'block'
  }
}

const loadMobileLenses = async () => {
  sliderLoading.value = true

  let leftSource = ''
  if (store.LeftSelectedVideoDetails && store.LeftSelectedVideoDetails.length > 0) {
    const leftItem = store.LeftSelectedVideoDetails.find(
      item =>
        item?.focalLength === store.LeftFocalLength && item?.transmission === store.LeftTransmission
    )
    if (leftItem) {
      switch (store.sceneType) {
        case 'desert':
          leftSource = leftItem.sceneImage1
          break
        case 'night':
          leftSource = leftItem.sceneImage2
          break
        case 'interior':
          leftSource = leftItem.sceneImage3
          break
      }
    }
  }

  let rightSource = ''
  if (store.RightSelectedVideoDetails && store.RightSelectedVideoDetails.length > 0) {
    const rightItem = store.RightSelectedVideoDetails.find(
      item =>
        item?.focalLength === store.RightFocalLength &&
        item?.transmission === store.RightTransmission
    )
    if (rightItem) {
      switch (store.sceneType) {
        case 'desert':
          rightSource = rightItem.sceneImage1
          break
        case 'night':
          rightSource = rightItem.sceneImage2
          break
        case 'interior':
          rightSource = rightItem.sceneImage3
          break
      }
    }
  }

  if (sceneBackgroundRef.value) {
    const leftImg = sceneBackgroundRef.value
    const onLeftLoad = () => {
      leftImg.classList.add('show')
      leftImg.removeEventListener('load', onLeftLoad)
    }
    leftImg.addEventListener('load', onLeftLoad)
    leftImg.src = leftSource || require('@/assets/img/no_scene_available.jpg')
  }

  if (sceneLensRef.value) {
    const rightImg = sceneLensRef.value
    const onRightLoad = () => {
      rightImg.classList.add('show')
      rightImg.removeEventListener('load', onRightLoad)
    }
    rightImg.addEventListener('load', onRightLoad)
    rightImg.src = rightSource || require('@/assets/img/no_scene_available.jpg')
  }

  sliderLoading.value = false
}

const loadSceneBg = async () => {
  await loadMobileLenses()
}

function setSceneType(scene) {
  store.setSceneType(scene)
}

const updateActiveIcon = () => {
  const activeDetail =
    activeSide.value === 'LEFT' ? leftSingleVideoDetail.value : rightSingleVideoDetail.value
  if (activeDetail && activeDetail.icon) {
    store.generateIcon(activeDetail.icon, iconRef)
  } else {
    if (iconRef.value) {
      iconRef.value.style.display = 'none'
    }
  }
}

watch(sceneWishlist, () => {
  generateSaveIcon()
  generateLeftSaveIcon()
  generateRightSaveIcon()
})

watch(singleVideoDetail, () => {
  generateSaveIcon()

  const lensCategoryName = store.data.find(
    lens => lens.id === singleVideoDetail.value?.lensCategoryId
  )?.name

  if (lensCategoryName) {
    singleVideoDetail.value.lensCategoryName = lensCategoryName
  }

  loadSceneBg()
})

watch(leftSingleVideoDetail, () => {
  generateLeftSaveIcon()
  loadMobileLenses()
  if (activeSide.value === 'LEFT') {
    updateActiveIcon()
  }
})

watch(rightSingleVideoDetail, () => {
  generateRightSaveIcon()
  loadMobileLenses()
  if (activeSide.value === 'RIGHT') {
    updateActiveIcon()
  }
})

watch(LeftTransmission, () => {
  const lensesItem = store.LeftSelectedVideoDetails.find(
    s => s?.focalLength === store.LeftFocalLength && s?.transmission === store.LeftTransmission
  )
  leftSingleVideoDetail.value = lensesItem
})

watch(RightTransmission, () => {
  const lensesItem = store.RightSelectedVideoDetails.find(
    s => s?.focalLength === store.RightFocalLength && s?.transmission === store.RightTransmission
  )
  rightSingleVideoDetail.value = lensesItem
})

watch(LeftFocalLength, () => {
  store.setLeftSelectedVideoDetails()
  const lensesItem = store.LeftSelectedVideoDetails.find(
    s => s?.focalLength === store.LeftFocalLength && s?.transmission === store.LeftTransmission
  )
  leftSingleVideoDetail.value = lensesItem
})

watch(RightFocalLength, () => {
  store.setRightSelectedVideoDetails()
  const lensesItem = store.RightSelectedVideoDetails.find(
    s => s?.focalLength === store.RightFocalLength && s?.transmission === store.RightTransmission
  )
  rightSingleVideoDetail.value = lensesItem
})

function handleSelectedVideoIdChange(side) {
  if (store.searchIsActive) {
    const navEntities = document.querySelectorAll('.nav-entity')
    navEntities.forEach(item => {
      item.style.transform = 'rotateX(0deg)'
    })
  }

  const isLeft = side === 'LEFT'
  if (isLeft) {
    store.setLeftSelectedVideoDetails()
    if (store.LeftSelectedVideoDetails && store.LeftSelectedVideoDetails.length > 0) {
      store.setLeftFocalLength(store.LeftSelectedVideoDetails[0]?.focalLength)
      store.setLeftTransmission(store.LeftSelectedVideoDetails[0]?.transmission)
    }
  } else {
    store.setRightSelectedVideoDetails()
    if (store.RightSelectedVideoDetails && store.RightSelectedVideoDetails.length > 0) {
      store.setRightFocalLength(store.RightSelectedVideoDetails[0]?.focalLength)
      store.setRightTransmission(store.RightSelectedVideoDetails[0]?.transmission)
    }
  }

  if (activeSide.value === side) {
    reloadFocalLength(side)
    reloadTransmission(side)
  }

  const details = isLeft ? store.LeftSelectedVideoDetails : store.RightSelectedVideoDetails
  const focalLength = isLeft ? store.LeftFocalLength : store.RightFocalLength
  const transmission = isLeft ? store.LeftTransmission : store.RightTransmission
  const selectedVideoId = isLeft ? store.LeftSelectedVideoId : store.RightSelectedVideoId

  const lensesItem = details.find(
    s => s?.focalLength === focalLength && s?.transmission === transmission
  )

  if (isLeft) {
    leftSingleVideoDetail.value = lensesItem
  } else {
    rightSingleVideoDetail.value = lensesItem
  }

  const listItem = document.getElementById(selectedVideoId)
  if (listItem) {
    store.scrollToItem(listItem)
  }
}

watch(LeftSelectedVideoId, () => handleSelectedVideoIdChange('LEFT'))
watch(RightSelectedVideoId, () => handleSelectedVideoIdChange('RIGHT'))

watch(SelectedVideo, () => {
  if (!store.SelectedVideo) return

  const formattedLens = store.SelectedVideo.toLowerCase().replace(/\s+/g, '-')
  if (activeSide.value === 'LEFT') {
    store.setLeftSelectedVideoId(formattedLens + '-left')
  } else {
    store.setRightSelectedVideoId(formattedLens + '-right')
  }
})

watch(SelectedFocalLength, () => {
  store.setSelectedVideoDetails()
  reloadTransmission()
  const lensesItem = store.SelectedVideoDetails.find(
    s =>
      s.focalLength === store.SelectedFocalLength && s.transmission === store.SelectedTransmission
  )

  singleVideoDetail.value = lensesItem
  store.generateIcon(lensesItem.icon, iconRef)
})

watch(SelectedTransmission, () => {
  store.setSelectedVideoDetails()

  const lensesItem = store.SelectedVideoDetails.find(
    s =>
      s.focalLength === store.SelectedFocalLength && s.transmission === store.SelectedTransmission
  )
  store.generateIcon(lensesItem.icon, iconRef)
  singleVideoDetail.value = lensesItem
})

watch(sceneType, async () => {
  generateSaveIcon()
  generateLeftSaveIcon()
  generateRightSaveIcon()

  await store.fetchData()

  const leftLensesExistInSceneType = findlensesExistanceInSceneType(
    store.LeftSelectedVideoId,
    store.data,
    false
  )
  const rightLensesExistInSceneType = findlensesExistanceInSceneType(
    store.RightSelectedVideoId,
    store.data,
    false
  )

  if (!leftLensesExistInSceneType) {
    store.setLeftSelectedVideoId(store.defaultLeftVideoId)
  } else {
    if (activeSide.value === 'LEFT') {
      const listItem = document.getElementById(store.LeftSelectedVideoId)
      if (listItem) store.scrollToItem(listItem)
    }
  }

  if (!rightLensesExistInSceneType) {
    store.setRightSelectedVideoId(store.defaultRightVideoId)
  } else {
    if (activeSide.value === 'RIGHT') {
      const listItem = document.getElementById(store.RightSelectedVideoId)
      if (listItem) store.scrollToItem(listItem)
    }
  }

  await loadMobileLenses()
})

watch(activeSide, async () => {
  await nextTick()

  // Ensure padding is correctly calculated when viewport is visible
  if (activeSide.value === 'LEFT' && leftViewport.value) {
    store.addHeightOntopAndBottom(leftViewport)
  } else if (activeSide.value === 'RIGHT' && rightViewport.value) {
    store.addHeightOntopAndBottom(rightViewport)
  }

  reloadFocalLength(activeSide.value)
  reloadTransmission(activeSide.value)

  if (focalLengthRef.value) {
    focalLengthRef.value.value =
      activeSide.value === 'LEFT' ? store.LeftFocalLength : store.RightFocalLength
  }
  if (transmissionRef.value) {
    transmissionRef.value.value =
      activeSide.value === 'LEFT' ? store.LeftTransmission : store.RightTransmission
  }

  updateActiveIcon()

  const activeId =
    activeSide.value === 'LEFT' ? store.LeftSelectedVideoId : store.RightSelectedVideoId
  if (activeId) {
    const listItem = document.getElementById(activeId)
    if (listItem) {
      setTimeout(() => {
        store.scrollToItem(listItem)
      }, 350)
    }
  }
})
</script>

<style scoped>
.video-control-mobile {
  bottom: 15px;
  padding: 0 10px;
  z-index: 3;
  width: 100%;
  flex-direction: column-reverse;
  align-items: end;
  justify-content: space-between;
  gap: 5px;
  min-height: 34px;
}

.video-control-mobile img {
  width: 22px;
  height: 26px;
  padding: 8px 0 4px 8px;
}

.lensesList {
  margin-right: 100px;
}

.fullscreen-img {
  opacity: 0.5;
}

.video-full-screen {
  position: absolute;
  top: 0;
}

@media screen and (max-width: 640px) {
  .lensesList {
    margin-left: 0;
    margin-right: 20px;
  }
}

.lenslist-container {
  display: flex;
  justify-content: center;
}

.video-timeline-bar {
  width: 100%;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  position: relative;
  border-radius: 10px;
}

.video-timeline-progress {
  position: absolute;
  left: 0;
  width: 0%;
  height: 100%;
  background: rgba(128, 128, 128, 0.5);
  border-radius: 10px;
}

video::-webkit-media-controls-play-button,
video::-webkit-media-controls-pause-button {
  display: block !important;
}

.mobile-details-container {
  margin: 0 auto;
  padding: 0 20px;
  max-width: 400px;
}

.new-badge {
  display: inline-block;
  background-color: #0f52ba;
  color: #fff;
  padding: 0.2rem 0.5rem;
  border-radius: 0.3rem;
  font-size: 0.7rem;
  margin-left: 0.5rem;
}

.scene-title {
  text-align: center;
  color: rgb(190, 190, 190);
  font-size: 22px;
  text-transform: uppercase;
  font-weight: 500;
  margin-block: 0;
}

.slider-container {
  border-radius: 0;
  display: flex;
  align-items: center;
}

.scene-fullscreen {
  bottom: 10px;
  right: 10px;
  opacity: 0.8;
}

.scene-info-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-block: 10px;
}

.scene-info-container img {
  width: 15px;
  opacity: 0.5;
}

.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.4);
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  transition: all 0.2s ease;
  padding: 10px;
}

.arrow-btn.active {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
}

.left-arrow {
  left: 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.right-arrow {
  right: 0;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.lensesList-left {
  justify-content: flex-start;
}

.lensesList-right {
  justify-content: flex-end;
}

:deep(.nav-title) {
  margin-top: 0;
}

:deep(.viewport-left) {
  text-align: left;
}

:deep(.viewport-right) {
  text-align: right;
  margin-right: 10px;
}

:deep(.viewport-right .lenses-list) {
  margin-right: 12px !important;
}

:deep(.viewport-right::before) {
  left: auto !important;
  right: 0 !important;
}

:deep(.viewport-right::after) {
  content: none !important;
}

:deep(.viewport-right .nav-link),
:deep(.viewport-right .nav-title) {
  display: block !important;
  text-align: right !important;
  padding-left: 0 !important;
  padding-right: 1.5rem !important;
}

:deep(.nested-list) {
  overflow: visible !important;
}

:deep(.viewport-right .nested-list) {
  margin: 0 !important;
  padding: 0 !important;
  padding-right: 0 !important;
}

:deep(.viewport-right .nav-item) {
  margin: 6px 0 !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: row-reverse !important;
}

:deep(.viewport-right .new-badge) {
  margin-left: 0 !important;
  margin-right: 0.5rem !important;
}

:deep(.vide-save-btn.scene-save.left-side-save) {
  top: 7px;
  left: 7px;
}

/* Slide Left Animation */
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Slide Right Animation */
.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
}
</style>
